
// React Imports
import * as React from "react";
import {useState, useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import { useForm } from "react-hook-form";

// Mui Imports

import {Backdrop, CircularProgress,  Fade, Stack} from "@mui/material";
import Box from "@mui/material/Box";


// App Imports
import {getSourcedCDP, updateCDPV
} from "../../ContractDataPoint/ContractDataPointClient";
import {
    advanceContract,
} from "../../Contract/ContractClient";
import {changeWorkQueue} from "../workQueueSlice";

import {
    updateRelatedExpressions
} from "../../ContractDataPointValue/ContractDataPointValueClient";
import DynamicCdpvValueField from "../../CommonComponents/DynamicCdpvValueField";
import Button from "@mui/material/Button";
import {getThisContractTopLevel} from "../../ExternalData/Product/ProductClient";
import dayjs from "dayjs";
import {changeWork} from "../../Work/workSlice";
import {changeWorkIssuance} from "../../WorkIssuance/workIssuanceSlice";



// main function







function WorkQueueCdpPanel(props) {
    let [filterContractSectionId, setFilterContractSectionId] = useState(0)
    const [collapsed, setCollapsed] = useState(false);
    const [fetching, setFetching] = useState(true);
    const [showDrawer, setShowDrawer] = useState(false);
    const [gridFilter, setGridFilter] = useState(103);
    const [workQueueCDP, setWorkQueueCDP] = useState([]);
    const [contractData, setContractData] = useState([]);
    // const [cdpFilter, setCdpFilter] = useState('all')
    const [sourceTooltip, setSourceTooltip] = useState([]);

    const [selectedCDP, setSelectedCDP] = useState([]);

    const [topRedCdp, setTopRedCdp] = useState(null);


    const selectorContractId = useSelector((state) => state.workQueueSlc.value.selectedContractId);
    const selectorContractStatus = useSelector((state) => state.workQueueSlc.value.selectedContractStatus);
    const selectorContractProperty = useSelector((state) => state.workQueueSlc.value.selectedContractProductId);
    const selectorContractLevel = useSelector((state) => state.workQueueSlc.value.selectedContractLevel);
    const selectorContractGuild = useSelector((state) => state.workQueueSlc.value.selectedContractGuild);

    const selectorInputMissingCount = useSelector((state) => state.workQueueSlc.value.selectedContractInputMissingCount);

    // ****************** BEGIN STATES ****************************

    const [submitting, setSubmitting] = useState(false);

    // ****************** END STATES ****************************

    const { control } = useForm();

    // const [selectorContractSectionContractId, setSelectorContractSectionContractId] = useState(useSelector((state) => state.workQueueSlc.value.cId));

    const selectorTriggerAdvance = useSelector((state) => state.workQueueSlc.value.triggerAdvance);

    const selectorTopRedCdpId = useSelector((state) => state.workQueueSlc.value.topRedCdpId);
    const selectorTopRedCdpvId = useSelector((state) => state.workQueueSlc.value.topRedCdpvId);
    const selectorTopRedDataPointId = useSelector((state) => state.workQueueSlc.value.topRedDataPointId);
    const selectorTopRedDataPointName = useSelector((state) => state.workQueueSlc.value.topRedDataPointName);
    const selectorTopRedDataType = useSelector((state) => state.workQueueSlc.value.topRedDataType);
    const selectorTopRedValue = useSelector((state) => state.workQueueSlc.value.topRedValue);
    const selectorTopRedMissingCount = useSelector((state) => state.workQueueSlc.value.topRedMissingCount);

    const dispatchData = useDispatch();


    useEffect(() => {
        console.log("CDP fetch triggered by cdp panel refresh = true");
        fetchWorkQueueCDP();
        dispatchData(changeWorkQueue({workQueueCdpPanelRefresh: false}));
    }, [useSelector((state) => state.workQueueSlc.value.workQueueCdpPanelRefresh)===true]);



    const fetchWorkQueueCDP = () => {
        if (selectorContractId != null
            // && selectorContractId !== 0
        ) {
            getSourcedCDP(selectorContractId)

                .then(data => {
                    console.log("for Contract #", selectorContractId);
                    console.log("CDP data set retrieved");
                    console.log(data);
                    setWorkQueueCDP(data);

                    const topRed = data.reduce((acc, item) => {
                        const matches =
                            item.mockOrigin === 'Input' &&
                            (item.mockValue == null || item.mockValue === '');

                        if (!matches) return acc;
                        if (!acc || Number(item.id) < Number(acc.id)) return item;
                        return acc;
                    }, null);

                    const topRedCount = data.filter(item =>
                        item.mockOrigin === 'Input' &&
                        (item.mockValue == null || item.mockValue === '')
                    ).length;

                    dispatchData(changeWorkQueue({topRedMissingCount: topRedCount}));
                    if(topRed === null)
                        // this triggers the grid refresh and show the title structure, etc.
                   {
                       dispatchData(changeWorkQueue({
                           newSetupContractId: selectorContractId,    fetchTopLevel: true
                       }));
                   }
                   else {
                    console.log("top red Cdp");
                    console.log(topRed);
                    dispatchData(changeWorkQueue({
                        topRedCdpId: topRed.id,
                        topRedCdpvId: topRed.cdpvId,
                        topRedDataPointId: topRed.dataPointId,
                        topRedDataPointName: topRed.dataPointName,
                        topRedDataType: topRed.dataType,
                        topRedValue: topRed.value,
                    }))
                   };
                 })
        }
    };



    const fetchContractTitle  = () => {
        getThisContractTopLevel(selectorContractId)

            .then(data => {
                console.log("Contract for Top Level Query = ", selectorContractId);
                console.log("Top Level Contract Title Data");
                console.log(data);
                dispatchData(changeWorkQueue({
                    propertyDropdownTitleId: data[0].id,
                    propertyDropdownTitleName: data[0].title,
                    propertyDropdownMultiSingle: data[0].multiSingle,
                    propertyDropdownExpansionDepth: data[0].expansionDepth,
                    cId: selectorContractId, workQueueExperience: "ShowMe",
                    workQueueCGridRefresh: true,workQueueCSGridRefresh: true, workQueueCDPGridRefresh: true, triggerAdvance: false
                }));
                console.log("propertyDropdownTitleId modified to equal data[0].id ", data[0].id);

                // setWorkQueueCDP(data);
            })
            .catch(error => {
                console.error("Error fetching CDP data:", error);
            });
    };


    useEffect(() => {
            console.log("Contract's top level fetch triggered by workQueueSlc.value.fetchTopLevel = true");
        fetchContractTitle()
            // handleAdvance();
            dispatchData(changeWorkQueue({fetchTopLevel: false}));
    }, [useSelector((state) => state.workQueueSlc.value.fetchTopLevel === true)]);




    function handleAdvance() {
        setSubmitting(true)
        // dispatchData(changeWorkQueue({ friendlyProgress: true}));
        console.log("Submitting...")
            console.log("standard advance triggered");
            console.log("selectorContractId",selectorContractId);
            console.log("selectorContractStatus",selectorContractStatus);
            console.log("selectorContractProperty",selectorContractProperty);
            console.log("selectorContractLevel",selectorContractLevel);
            console.log("selectorContractGuild",selectorContractGuild);
            advanceContract(selectorContractId).then(() => {

                console.log("Submitting off") })
                .finally(() => {
                    dispatchData(changeWorkQueue({workQueueCdpPanelRefresh: true}));
                    setSubmitting(false)
                    // dispatchData(changeWorkQueue({ friendlyProgress: false}));
                })
        };



    useEffect(() => {
        if(selectorTriggerAdvance === true)
        {
            console.log("Advance triggered by workQueueSlc.value.triggerAdvance = true");
            handleAdvance()
            // handleAdvance();
            dispatchData(changeWorkQueue({triggerAdvance: false}));}
    }, [useSelector((state) => state.workQueueSlc.value.triggerAdvance === true)]);




    function handleSubmit(data) {
        // setSubmitting(true)
        // console.log("Submitting...")
        console.log("this is my_cdp_id")
        console.log(selectorTopRedCdpId)
        console.log("this is my_data_type")
        console.log(selectorTopRedDataType)
        console.log("this is my value")
        console.log(selectorTopRedValue)
        console.log("this is my data")
        console.log({data})

        updateCDPV(
            selectorTopRedCdpId, selectorTopRedDataType,
            selectorTopRedDataType === 'DATE' ? dayjs(selectorTopRedValue).format('MM/DD/YYYY') : selectorTopRedValue
        )
            .then(() => {
                console.log("ContractDataPointValue edited")
                console.log("my contract id")
                console.log(selectorContractId)
            }).catch(err => {
            console.log(err)
            console.log("Error!")

        }).then(() => {
            updateRelatedExpressions(selectorTopRedCdpId);
            console.log("update related expression");
            console.log("cdp value = ", selectorTopRedValue);
            console.log("input missing count", selectorInputMissingCount);
        })
            .then(() =>{
                if(selectorTopRedMissingCount === 1)
                {
                    // setSubmitting(true)
                    dispatchData(changeWorkQueue({
                        // friendlyProgress: true,
                        topRedCdpId: null,
                        topRedCdpvId: null,
                        topRedDataPointId: null,
                        topRedDataPointName: null,
                        topRedDataType: null,
                        topRedValue: null,
                        triggerAdvance: true}));
                }
                else{
                dispatchData(changeWorkQueue({workQueueCdpPanelRefresh: true}));}
            }).finally(()=>{
            })};



    function handleExit (){
        console.log("handleExit called");
        dispatchData(changeWork({workTabsIndex: 2,
            searchScreenVisible: false,
            workDashboardVisible: false,
            workContractVisible: true,
            workIssuanceVisible: false}));
        dispatchData(changeWorkQueue({selectedContractId: 0, selectedContractName: null,propertyDropdownListState:true,
            workQueueFinalize: false, propertyDropdownTitleId: null, bigAddButtonDisplay: true}));
        dispatchData(changeWorkIssuance({
            calcSearchProductId: 0,
            versionMode: null,
            versionStatusId: null,
            versionStatusName: null,
            periodEndDate: null,
            testScenarioNumber : null,
            testScenarioName : null,
            testScenarioPropertyId : null,
            testScenarioPropertyName : null,
        }));
        // dispatchData(changeWorkQueue({
        //     newSetupContractId: selectorContractId,    fetchTopLevel: true
        // }));
    }


    const fadeKey = [
        selectorTopRedCdpId,
        selectorTopRedCdpvId,
        selectorTopRedDataPointId,
        selectorTopRedDataPointName,
        selectorTopRedDataType,
    ].join('|');

    const alignToFlex = { left: 'flex-start', center: 'center', right: 'flex-end' };

    const align = 'center'; // 'left' | 'center' | 'right';



    return (
        <Box>
            {    submitting &&
                 <Backdrop open invisible sx={{ zIndex: (t) => t.zIndex.modal + 1 }}>
            <CircularProgress size="3rem" />
        </Backdrop>
            }
            {!submitting && <Box>
                <Fade in timeout={2000} key={fadeKey} mountOnEnter unmountOnExit>
            <Box>
            <Box
                sx={{
                    width: 300,
                    height: 200,
                }}
            />
            <Box sx={{ width: '100%', display: 'flex', justifyContent: alignToFlex[align], alignItems: 'center',   }}>
                {/* Panel */}

                <Box
                    sx={{
                        width: 800,
                        height: 300,
                        '& h2': { m: 0.5, textAlign: align }, // make all <h2> follow the text alignment
                    }}
                >
                    {/*<h4>{selectorTopRedCdpId}</h4>*/}
                    {/*<h4>{selectorTopRedCdpvId}</h4>*/}
                    {/*<h4>{selectorTopRedDataPointId}</h4>*/}

                    {/* This row spans full panel width; justify matches the chosen alignment */}
                    <Stack
                        direction="row"
                        spacing={0}
                        alignItems="baseline"
                        sx={{ width: '100%', justifyContent: alignToFlex[align] }}
                    >

                        {(selectorTopRedDataPointId === 530 || selectorTopRedDataPointId === 74 || selectorTopRedDataPointId === 532
                        ||  selectorTopRedDataPointId === 3557 ||  selectorTopRedDataPointId === 3558 ||  selectorTopRedDataPointId === 532)
                        && <h2>Choose the&nbsp;{selectorTopRedDataPointName}</h2>}
                        {selectorTopRedDataPointId === 71 && <h2>Choose the&nbsp;{selectorTopRedDataPointName}</h2>}
                        {(selectorTopRedDataType === 'INTEGER' && (selectorTopRedDataPointId !== 71 && selectorTopRedDataPointId !== 530
                                && selectorTopRedDataPointId !== 74
                                && selectorTopRedDataPointId !== 532 &&  selectorTopRedDataPointId !== 3557 &&  selectorTopRedDataPointId !== 3558 &&
                                selectorTopRedDataPointId !== 532))
                            && <h2>How Many&nbsp;{selectorTopRedDataPointName}</h2>}
                          {(selectorTopRedDataType === 'CODE' && selectorTopRedDataPointId !== 71) && <h2>Select the&nbsp;{selectorTopRedDataPointName}</h2>}
                        {selectorTopRedDataType === 'YES_NO' && <h2>{selectorTopRedDataPointName}?</h2>}
                        {selectorTopRedDataType === 'DOLLARS' && <h2>What is the&nbsp;{selectorTopRedDataPointName}&nbsp;amount?</h2>}
                        {selectorTopRedDataType === 'DECIMAL' && <h2>What is the&nbsp;{selectorTopRedDataPointName}&nbsp;amount?</h2>}
                        {selectorTopRedDataType === 'TIME' && <h2>What is the&nbsp;{selectorTopRedDataPointName}&nbsp;?</h2>}
                        {selectorTopRedDataType === 'PERCENTAGE' && <h2>What is the&nbsp;{selectorTopRedDataPointName}&nbsp;?</h2>}
                        {selectorTopRedDataType === 'DATE' && <h2>What is the&nbsp;{selectorTopRedDataPointName}&nbsp;?</h2>}

                    </Stack>
                    <br/>
                    <br/>

                    {/*<h4>{selectorTopRedDataType}</h4>*/}
                    {/*<h4>{selectorTopRedValue}</h4>*/}
                    <Box sx={{                display: 'flex', justifyContent: 'center', width: '100%' }} >
                        {selectorTopRedCdpId !== null &&
                            <Stack
                        direction="row"
                        spacing={2}
                        // alignItems="baseline"
                        sx={{ width: '100%', justifyContent: alignToFlex[align] }}
                    >

                    <DynamicCdpvValueField

                        inputAlign={align}              // pass through for text alignment
                        selectorDataPointId={selectorTopRedDataPointId}
                        selectorValue={selectorTopRedValue}
                        selectorDataType={selectorTopRedDataType}
                        selectorContext={'WorkQueuePanel'}
                        selectorLabel={''}
                        autoFocus
                        control={control}
                    />

                    <Button
                        color="primary"
                        onClick={() => handleSubmit(selectorTopRedValue)}
                        sx={{ typography: 'h5', textTransform: 'none', p: 2 }}
                    >OK</Button>
                    </Stack>}

                    </Box>

                </Box>


            </Box>
               <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center', mt: 4 }}>

                    <Button
                        color="primary"
                        onClick={() => handleExit()}
                        sx={{ typography: 'h5', textTransform: 'none', p: 2 }}
                    >EXIT</Button>
                </Box>
            </Box>

         </Fade>
            </Box>
            }
        </Box>
    );



}
export default WorkQueueCdpPanel;



